import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { colors } from 'lib/prisma-styles';

import { NavItemComponentProps } from '../../types';

const StyledContainer = styled.div<{ hasBeenSelected: boolean, isLastItem: boolean }>`
  margin-left: 1.333333333rem;
  padding: 0 0 1.333333333rem 1.5rem;
  border-left: 4px solid transparent;
  border-left-color: ${({ hasBeenSelected }) => hasBeenSelected
    ? colors.interactive.primaryAction
    : '#d7dae0'};
  box-sizing: border-box;

  ${({ isLastItem }) => isLastItem && css`
    padding-bottom: 0;
  `}
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledTitle = styled.div<{ isSelected: boolean }>`
  position: relative;
  margin-bottom: 0.333333333rem;
  font-size: 1.666666667rem;
  font-weight: 700;
  text-transform: capitalize;

  ${({ isSelected }) => isSelected && css`
    color: ${colors.interactive.primaryAction};

    &::before,
    &::after {
      content: '';
      position: absolute;
      display: inline-block;
      background-color: ${colors.interactive.primaryAction};
    }

    &::before {
      width: 1.333333333rem;
      height: 1.333333333rem;
      border-radius: 50%;
      top: 0.5rem;
      left: -2.333333333rem;
    }

    &::after {
      width: 0.333333333rem;
      height: 1rem;
      top: 0;
      left: -1.833333333rem;
    }
  `};
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.166666667rem;

  &:not(:last-child) {
    margin-bottom: 0.333333333rem;
  }
`;

const StepNavigationItem = ({
  children,
  currentStepIndex,
  stepIndex,
  stepName,
  isSelected,
  numberOfSteps,
}: NavItemComponentProps) => {
  const [hasBeenSelected, setHasBeenSelected] = useState(false);
  const [isLastItem, setIsLastItem] = useState(false);

  useEffect(() => {
    setHasBeenSelected(currentStepIndex > stepIndex);
  }, [currentStepIndex, stepIndex]);

  useEffect(() => {
    setIsLastItem(stepIndex === numberOfSteps - 1);
  }, [stepIndex, numberOfSteps]);

  return (
    <StyledContainer data-cy={'wf-edit-left-nav-item'} hasBeenSelected={hasBeenSelected} isLastItem={isLastItem}>
      <StyledHeader>
        <StyledTitle isSelected={isSelected}>
          {stepName}
        </StyledTitle>
      </StyledHeader>
      <StyledContentContainer>
        {children}
      </StyledContentContainer>
    </StyledContainer>
  );
};

export default StepNavigationItem;
